export enum DeliveryError {
  InvalidPhoneNumber = 'InvalidPhoneNumberException',
  BlockedPhoneNumber = 'BlockedPhoneNumberException',
  PhoneNumberCannotReceiveSms = 'PhoneNumberCannotReceiveSmsException',
  TechnicalErrorWhileSendingSms = 'TechnicalErrorWhileSendingSmsException',
  UnsupportedSmsLanguage = 'UnsupportedSmsLanguageException',
  UnauthorizedSmsDelivery = 'UnauthorizedSmsDeliveryException',
  CannotDeliver = 'CannotDeliverException',
}
